import {configureYup} from '@yoco/design-system-react-native';
console.log("CONFIGURE YUP!")
configureYup({globalDefaultCountryCode: 'ZA'});

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

async function main() {
  const App = (await import("./App.tsx")).default;

  createRoot(document.getElementById("app-root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

main();

